import { withInstall } from '@ideaz/utils'
import FullScreen from './src/index'

export default withInstall(FullScreen)
